import { RouterProvider } from 'react-router-dom';
import { router } from './Routes';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';

export function App() {
  return <RouterProvider router={router} />;
}
